import React from "react";
import { useNavigate } from "react-router-dom";
import "./DDNextBar.scss";

/** Barra «Siguiente · …» al pie de cada paso del proceso DD. */
export function DDNextBar({ title, text, button, to }) {
  const navigate = useNavigate();
  return (
    <div className="dd-next no-print">
      <div className="dd-next__tx"><b>{title}</b>{text}</div>
      <button className="dd-next__btn" onClick={() => navigate(to)}>{button} →</button>
    </div>
  );
}
